import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "display-5 text-center" }, "Newsletter", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_3 = { class: "card mt-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, "Send newsletter", -1)
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "row mb-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Title", -1)
const _hoisted_8 = { class: "col-sm" }
const _hoisted_9 = { class: "row mb-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "URL", -1)
const _hoisted_11 = { class: "col-sm" }
const _hoisted_12 = { class: "row mb-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "List Level", -1)
const _hoisted_14 = { class: "col-sm" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", {
  value: "-1",
  disabled: "disabled"
}, "Choose a list", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Test", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Major", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Minor", -1)
const _hoisted_19 = { class: "row mb-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Body", -1)
const _hoisted_21 = { class: "col-sm" }
const _hoisted_22 = { class: "row mb-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-2" }, null, -1)
const _hoisted_24 = { class: "col-sm" }
const _hoisted_25 = { class: "form-check form-switch" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "sendDiscord"
}, "Send to Discord", -1)
const _hoisted_27 = {
  key: 0,
  class: "text-success"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode($setup["VForm"], { form: $setup.sendForm }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createVNode($setup["VField"], {
                  class: "form-control",
                  name: "title",
                  "show-error": false
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createVNode($setup["VField"], {
                  class: "form-control",
                  name: "url",
                  "show-error": false
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createVNode($setup["VField"], {
                  class: "form-control",
                  name: "list",
                  is: "select",
                  "show-error": false
                }, {
                  default: _withCtx(() => [
                    _hoisted_15,
                    _hoisted_16,
                    _hoisted_17,
                    _hoisted_18
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                _createVNode($setup["VField"], {
                  class: "form-control",
                  name: "body",
                  is: "textarea",
                  "show-error": false
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    id: "sendDiscord",
                    name: "sendDiscord",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.sendForm.data.sendDiscord) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, $setup.sendForm.data.sendDiscord]
                  ]),
                  _hoisted_26
                ])
              ])
            ]),
            _createVNode($setup["VError"], {
              class: "d-inline",
              is: "span"
            }),
            ($setup.success)
              ? (_openBlock(), _createElementBlock("span", _hoisted_27, "Newsletter sent!"))
              : _createCommentVNode("", true),
            _createVNode($setup["VSubmit"], { class: "float-end" })
          ]),
          _: 1
        }, 8, ["form"])
      ])
    ])
  ], 64))
}